/*
 * NOTE: This is an auto-generated file created by Iconic.
 *
 * You should not need to edit this file directly; if you need to add/remove any
 * icon modules, you can rebuild it by running `yarn icons:make`.
 */
import * as React from 'react'

import VacasaWrapper from '../Wrapper'

const VacasaPlayIcon: React.FunctionComponent = () => {
  return (
    <VacasaWrapper id="playIcon" viewBox="0 0 16 20">
      <g
        id="Symbols"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g
          id="Icons/UI/-play"
          transform="translate(-4.000000, -2.000000)"
          fill="#ffffff"
        >
          <path
            d="M5.54075759,2.16045709 L19.5407576,11.1604571 C20.1530808,11.5540934 20.1530808,12.4491777 19.5407576,12.842814 L5.54075759,21.842814 C4.87524596,22.270643 4,21.7928014 4,21.0016356 L4,3.00163557 C4,2.21046977 4.87524596,1.73262818 5.54075759,2.16045709 Z"
            id="Shape"
          ></path>
        </g>
      </g>
    </VacasaWrapper>
  )
}

export default React.memo(VacasaPlayIcon)
